import styled from 'styled-components';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { spacing } from 'ui/theme';
import { testIds as clpTestIds } from 'modules/creativeLibrary/components/CreativeLibraryPanel';

import { usePanelContext } from '../../contexts/Panel';
import { useTranslations } from '../../hooks/useTranslations';
import { PanelIntent } from '../../types';

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1 1 auto;
  column-gap: ${spacing.half};
`;

export const PanelFooter = () => {
  const { t } = useTranslations();
  const {
    assetUrl,
    imageAttrState,
    imgMetadata,
    nonCustomizableAttrs,
    onCancel,
    onClose,
    onInsert,
    onSelect,
    initialIntent,
  } = usePanelContext();

  // inserting (or replacing) an image into the editor
  const handleInsert = () => {
    if (onInsert) {
      onInsert({ ...imageAttrState, ...nonCustomizableAttrs });
    }
    onClose();
  };

  // inserting (or replacing) the image url into a form field
  const handleSelect = () => {
    if (onSelect) {
      onSelect(assetUrl, imgMetadata);
      onClose();
    }
  };

  return (
    <Footer>
      <Button
        onClick={onCancel}
        size={BUTTON_SIZES.MEDIUM}
        variant={BUTTON_VARIANTS.GHOST}
        data-test={clpTestIds.panelFooter.footerBtnCancel}
      >
        <span>{t('button.cancel')}</span>
      </Button>
      {!!onSelect && (
        <Button
          data-test={clpTestIds.panelFooter.footerBtnSelect}
          onClick={handleSelect}
          size={BUTTON_SIZES.MEDIUM}
          variant={BUTTON_VARIANTS.PRIMARY}
        >
          <span>{t('button.select')}</span>
        </Button>
      )}
      {!!onInsert && (
        <Button
          data-test={clpTestIds.panelFooter.footerBtnInsert}
          onClick={handleInsert}
          size={BUTTON_SIZES.MEDIUM}
          variant={BUTTON_VARIANTS.PRIMARY}
        >
          <span>{t(initialIntent === PanelIntent.Insert ? 'button.insert' : 'button.save')}</span>
        </Button>
      )}
    </Footer>
  );
};
